import { Component } from '@angular/core';
import { AssociationDemoCompetitionJudgeEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Competition Judges') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-associationdemocompetitionjudge-form',
    templateUrl: './associationdemocompetitionjudge.form.component.html'
})
export class AssociationDemoCompetitionJudgeFormComponent extends BaseFormComponent {
    public record!: AssociationDemoCompetitionJudgeEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'competitionDetails', sectionName: 'Competition Details', isExpanded: true },
            { sectionKey: 'judgeProfile', sectionName: 'Judge Profile', isExpanded: true },
            { sectionKey: 'professionalBackground', sectionName: 'Professional Background', isExpanded: true },
            { sectionKey: 'timelineAndCompensation', sectionName: 'Timeline and Compensation', isExpanded: true },
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false }
        ]);
    }
}

